import React from 'react';

const CaroleLynneRichardson = (
    <>
    <p>Carole-Lynne leads Symphony’s Care Teams, serving seniors, their families and their professional advisors.  She has an exceptional career in home health care, palliative and hospice care.  Carole-Lynne is known for strong client advocacy as well as her innovation in improving support for seniors living at home.  She excels at building trusting relationships with her clients.  In Arizona, she knows well the best local providers of services in the home and other settings.  Carole-Lynne is a graduate of Nipissing University with a BA in Psychology.</p>
    </>
  );

export default CaroleLynneRichardson;